module.exports = __webpack_public_path__ + "img/login-bg-v1-blue.7cb3e378.jpg";